export default "__VITE_ASSET__CN86G9le__"